<template>
  <div class="row">
    <div class="col-md-12 card">
        <div class="card-header">
            <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-8 col-xs-12">
                  <h5 class="card-title">{{ $t('trainer_details')}}</h5>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-4 col-xs-12 text-center">
                  <a class="btn btn-xs text-white" style="background-color:red" @click.prevent="goBack()">
                    <i class="fa fa-backward"></i>
                    {{ $t('back') }}
                  </a>
                </div>
            </div>
        </div>
        <div class="card-body">
            <table class="table table-bordered" v-loading="loadingTrainer" :element-loading-text="$t('loading_data')+'...'">
                <tbody>
                    <tr>
                        <th width="200px">{{ $t('name') }}</th>
                        <td>{{ trainers.fullName }} </td>
                    </tr>
                    <tr>
                        <th>{{ $t('email') }}</th>
                        <td>{{ trainers.email }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('country') }}</th>
                        <td>{{ trainers.country }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('ngo') }}</th>
                        <td>{{ trainers.ngo }}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
    <div class="col-md-12 card">
          <div class="card-header">
            <div class="row">
                <div class="col-md-4">
                  <h5>{{ $t('farmers') }}</h5>
                </div>
                <div class="col-md-4">
                 <fg-input>
                    <el-select size="large" class="select-primary" v-model="country" filterable clearable :placeholder="$t('select_country')">
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.name"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-4">
                  <fg-input>
                      <el-select size="large" class="select-primary" v-model="ngo" filterable clearable :placeholder="$t('select_ngo')">
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.name"></el-option>
                      </el-select>
                  </fg-input>
               </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm" placeholder="Search" v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
             </div>
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                    <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
                       <template slot-scope="props">
                            <p-button type="success" size="sm" icon title="Click to view farmer details" @click="viewDetails(props.$index, props.row)">
                               <i class="fa fa-eye"></i>
                            </p-button>
                       </template>
                    </el-table-column>
                  </el-table>
             </div>
          </div>
          <div class="card-footer">
            <paginate :pagination="pagination" :metadata="metaData" :allData="getTrainerFarmers"></paginate>
          </div>
      </div>
  </div>
</template>
<script>
   import Resource from "@/util/Api/resource.js";
   import PPagination from "src/components/UIComponents/Pagination.vue";
   import Paginate from '@/components/UIComponents/Paginate.vue';
   import Con from "@/util/helpers.js";
   const TrainersResource = new Resource("user");
   const CatResources = new Resource("category/childrenGivenParent");

   export default {
     components:{
        PPagination,
        Paginate
     },
     data() {
       return {
          loading:false,
          loadingTrainer: false,
          tableColumns: [
              {prop: "name",label: this.$t("full_name"),},
              {prop: "email",label: this.$t("email"),},
              {prop: "phone",label: this.$t("phone"),},
              {prop: "community",label: this.$t("community"),},
              {prop: "country",label: this.$t("country")},
              {prop: "ngo",label: this.$t("ngo")},
          ],
          trainers:{
              fullName:'',
              email:'',
              country:'',
              ngo:'',
          },
          farmer: {
              id:'',
              name:'',
              profile:'',
              email:'',
              phone:'',
              hectares:'',
              people:'',
              harvest:'',
              ngo:'',
              country:'',
              community:'',
              postTemplateID:'',
          },
          pagination:{
              perPage: 10,
              perPageOptions: [10, 20, 30, 60, 500, 1000],
              currentPage: 1,
              nextPage:'',
              prevPage:'',
              total:'',
              from:'',
              to:'',
              page:'',
         },
         country:'',
         ngo:'',
         trainerFarmers:[],
         searchQuery:'',
         Countries:[],
         tableData:[],
         NGO:[],
         metaData: {
            meta:'',
            links:''
         },
       }
     },

     methods: {
        // view farmer harvest
        async viewDetails(index, row) {
          localStorage.setItem("showButton", 0)
          this.$router.push({
              name: "FarmersDetails",
              params: { post: row }
          });
        },

        // Get all NGOs in a categories
        async getNGOs() {
          await CatResources.get(1).then(response => {
            this.NGO = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },

        // Get all countries in a category
        async getCountry() {
          await CatResources.get(2).then(response => {
            this.Countries = response.data;
          }).catch(error => {
            this.showAlertMessage(error.response.data.message, "error");
          });
        },

        // function to go back to previuos page
        goBack() {
            this.$router.push({name: "ReportTrainer"});
        },

        // get trainer details
        async getTrainerDetail() {
            this.loadingTrainer = true;
            let trainerID = localStorage.getItem('trainerID');
            let roleID = localStorage.getItem('roleID');

             await TrainersResource.viewFarmer(trainerID, roleID)
             .then((response) => {
                  let trainers = response.data.userDetails;
                  this.trainers.fullName = trainers[0].surname + " " + trainers[0].name;
                  this.trainers.email = trainers[0].email;
                  this.trainers.country = trainers[0].location_Name;
                  this.trainers.ngo = trainers[0].ngo_Name;
                  this.loadingTrainer = false;
             }).catch(error => {
                 this.loadingTrainer = false;
                 console.log('Failed', 'Failed getting trainer information ' + error);
             });
        },

        // Parse data
        parseAnswer(answer) {
            let data = "";
            if(answer.indexOf('"') > -1) {
              data = JSON.parse(answer);
            } else {
              data = answer;
            }
            return data;
        },

        // Format farmers data
        formatFarmersData(data) {
          this.trainerFarmers = [];
          data.forEach(farmer => {

              this.farmer = [];
              this.farmer.id = farmer.post.id;
              this.farmer.postTemplateID = farmer.post.postTemplateID;

              farmer.postContent.forEach((element, key) => {
                    if(element.Question.title.toLowerCase() === "name") {
                        if(element.Answer) {
                          this.farmer.first_name = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.first_name = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "surname") {
                        if(element.Answer) {
                          this.farmer.last_name = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.last_name = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "email") {
                        if(element.Answer) {
                          this.farmer.email = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.email = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "phone number") {
                        if(element.Answer) {
                          this.farmer.phone = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.phone = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "profile image") {
                        if(element.Answer) {
                          this.farmer.profile = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.profile = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "hectares") {
                      if(element.Answer) {
                          this.farmer.hectares = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.hectares = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "people") {
                        if(element.Answer) {
                          this.farmer.people = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.people = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "select ngo") {
                        if(element.Answer) {
                          this.farmer.ngo = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.ngo = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "select country") {
                        if(element.Answer) {
                          this.farmer.country = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.country = "";
                        }
                    }

                    if(element.Question.title.toLowerCase() === "community") {
                        if(element.Answer) {
                          this.farmer.community = this.parseAnswer(element.Answer);
                        } else {
                          this.farmer.community = "";
                        }
                    }
              });

              this.farmer.name = this.farmer.first_name + " " + this.farmer.last_name;
              this.trainerFarmers.push(this.farmer);

          });

          let filterData = [];

          this.trainerFarmers.forEach((value) => {
            if(value.name !== undefined) {
              filterData.push(value);
            }
          });


          this.tableData = [...filterData, ...this.tableData];
        },


        // All farmer details
        async getTrainerFarmers(page_url) {
          let trainerID = localStorage.getItem('trainerID');
          let path = "post/trainsers/farmers/Farmer/" + trainerID;
          this.loading = true;
          if(page_url) {
             page_url = Con.splitStringLinks(page_url);
          }
          await new Resource(path).list(page_url)
          .then(response => {
              this.formatFarmersData(response.data.data);
              this.metaData.meta = response.data.meta;
              this.metaData.links = response.data.links;
              this.loading = false;
          })
          .catch(error => {
              this.loading = false;
              console.log("Error: ", error);
          });
      },

      paginate(array, length, pageNumber){
          this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
          this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
          this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
          this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
          this.pagination.page = Math.ceil(array.length / length);
          this.pagination.total = array.length;
          return array.slice((pageNumber - 1) * length, pageNumber * length);
      },

     },

     mounted() {
       this.getNGOs();
       this.getCountry();
       this.getTrainerDetail();
       this.getTrainerFarmers();
     },

    computed: {

        filterData() {
            let result = this.tableData;
            if (this.searchQuery) {
                result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                    })
                });
            } else if(this.country){
              result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.country.toLowerCase()) > -1);
                    })
              });
            } else if(this.ngo){
              result = result.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return (String(row[key]).toLowerCase().indexOf(this.ngo.toLowerCase()) > -1);
                    })
              });
            }
            return result;
        },

        paginated(){
          return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
        },

    },

   }
</script>
